<template>
  <transition name="modal" v-if="show">
    <div class="modal-mask">
      <div class="cell">
        <div
          class="modal-container card-small card"
          :class="{ 'w-75': large, 'w-50': !large }"
        >
          <div class="card">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    title: String,
    showing: Boolean,
    fullwidth: Boolean,
    large: Boolean,
  },
  computed: {
    show: {
      get() {
        return this.showing;
      },
      set() {
        this.$parent.$emit('modal:close');
      },
    },
  },
  methods: {
    hide() {
      this.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-container {
  max-width: 90vw;
  width: inherit;
  margin: 0px auto;
  transition: all 0.3s ease;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.cell {
  display: table-cell;
  vertical-align: middle;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
